import { BaseModel } from '@red/data-access';
import { Expose } from 'class-transformer';
import { IEnhancedLeadershipDesignationModel } from '../interfaces/enhanced-leadership-designation.interface';


export class EnhancedLeadershipDesignationModel extends BaseModel implements IEnhancedLeadershipDesignationModel {
  @Expose()
  id!: number;

  @Expose()
  code!: string;

  @Expose()
  name!: string;

  @Expose()
  createdAt!: string;

  @Expose()
  createdBy!: string;

  @Expose()
  updatedAt!: string;

  @Expose()
  updatedBy!: string

  @Expose()
  sequence!: number;
}

